<template>
    <div>
        <div
            class="flex justify-between items-center"
            @click="expanded = !expanded"
        >
            <slot name="title" />
            <slot name="icon">
                <div class="arrow-right" :class="{'rotate-arrow-down': expanded}"></div>
            </slot>
        </div>
        <div v-if="expanded" class="pl-3">
            <slot name="items" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const expanded = ref(false);
/*
export default {
    data(){
        return {
            expanded:false
        }
    }
}
*/
</script>
